import { DATE_FORMAT_DEFAULT, parseFormDay, formatTime } from '../datetime';

export const Gender = {
  Male: 'Male',
  Female: 'Female',
};

export const BookerFieldNames = {
  GivenName: 'givenName',
  FamilyName: 'familyName',
  Email: 'email',
  Mobile: 'mobileNumber',
  CountryCode: 'countryCode',
  Region: 'region',
  LoyaltyId: 'loyaltyId',
  OracleId: 'oracleId',
};

export const TravellerFieldNames = {
  Gender: 'gender',
  GivenName: 'givenName',
  FamilyName: 'familyName',
  DOB: 'dateOfBirth',
  Region: 'region',
  LoyaltyId: 'loyaltyId',
  LoyaltyTier: 'loyaltyTier',
  NavitaireCustomerNumber: 'navitaireCustomerNumber',
  OutboundFlightBaggage: 'outboundFlight',
  ReturnFlightBaggage: 'returnFlight',
  TravelDocumentType: 'travelDocumentType',
  TravelDocumentNumber: 'travelDocumentNumber',
  TravelDocumentExpiry: 'travelDocumentExpiry',
};

export const TravellerFieldNamesToBooker = [
  TravellerFieldNames.GivenName,
  TravellerFieldNames.FamilyName,
];

export const BookerAsTravellerFieldNames = [
  BookerFieldNames.GivenName,
  BookerFieldNames.FamilyName,
];

export const mappingFieldNames = {
  [TravellerFieldNames.GivenName]: BookerFieldNames.GivenName,
  [TravellerFieldNames.FamilyName]: BookerFieldNames.FamilyName,
};

export const getCountryFromDialingCode = (dialingCode, countries = []) =>
  countries.length &&
  dialingCode &&
  countries.find(
    ({ dialingCode: propDialingCode }) => propDialingCode === dialingCode
  );

export const getBookerDetailFromSSO = (
  credential,
  countries,
  defaultCountryCode
) => {
  if (credential && credential.ssoData) {
    const {
      mobilePhone,
      firstName,
      lastName,
      username,
      country: ssoCountryCode,
      dialingCode,
      loyaltyId,
    } = credential.ssoData;

    const countryFromDialingCode = getCountryFromDialingCode(
      dialingCode,
      countries
    );

    // If have no "dialingCode"
    // Should use the "defaultCountry" instead of "ssoCountryCode" for the dialingCode
    // "defaultCoutry" was converted from the Locale
    const country = defaultCountryCode || ssoCountryCode;

    return {
      [BookerFieldNames.GivenName]: firstName,
      [BookerFieldNames.FamilyName]: lastName,
      [BookerFieldNames.Region]: ssoCountryCode,
      [BookerFieldNames.CountryCode]: countryFromDialingCode
        ? countryFromDialingCode.countryCode
        : country,
      [BookerFieldNames.Mobile]:
        dialingCode &&
        mobilePhone &&
        mobilePhone.toString().indexOf(dialingCode) === 0
          ? mobilePhone.substring(dialingCode.length, mobilePhone.length)
          : mobilePhone,
      [BookerFieldNames.Email]: username,
      [BookerFieldNames.LoyaltyId]: loyaltyId,
    };
  }
};

export const getTravellerDetailFromMember = member => {
  if (member) {
    const {
      dateOfBirth,
      gender,
      firstName,
      lastName,
      country: memberCountry,
      issuingCountry,
      loyaltyTier,
      loyaltyId,
      navitaireCustomerNumber,
    } = member;

    const country = memberCountry || issuingCountry;
    let checkedDob = '';
    if (dateOfBirth) {
      try {
        checkedDob = formatTime(
          parseFormDay(dateOfBirth, 'ddMMyyyy'),
          DATE_FORMAT_DEFAULT
        );
      } catch {
        // do nothing
      }
    }

    return {
      [TravellerFieldNames.GivenName]: firstName,
      [TravellerFieldNames.FamilyName]: lastName,
      [TravellerFieldNames.DOB]: checkedDob,
      [TravellerFieldNames.Gender]:
        !gender || gender === 'male' ? Gender.Male : Gender.Female,
      [TravellerFieldNames.Region]: country,
      loyaltyTier,
      loyaltyId,
      navitaireCustomerNumber,
    };
  }
};

export const getTravellerDetailFromSSO = (credential, defaultCountrycode) => {
  if (credential && credential.ssoData) {
    const ssoMember = getTravellerDetailFromMember(
      credential.ssoData,
      defaultCountrycode
    );
    return ssoMember[TravellerFieldNames.Region]
      ? ssoMember
      : { ...ssoMember, [TravellerFieldNames.Region]: defaultCountrycode };
  }
};

export const someFieldsNotEmpty = (fieldNames = [], detail = {}) =>
  fieldNames.some(fieldName => Boolean(detail[fieldName]));

export const existFieldName = (fieldName, fieldNames = []) =>
  fieldNames.indexOf(fieldName) >= 0;

export const copyToBooker = (traveller, booker = {}) => {
  TravellerFieldNamesToBooker.forEach(fieldName => {
    booker[mappingFieldNames[fieldName]] = traveller[fieldName];
  });
  return booker;
};

export const prepareSpecialRequestForCheckout = specialRequests => {
  return specialRequests
    .filter(request => request.value.length > 0)
    .map(request => {
      return {
        id: request.id,
        value: request.value.map(item => ({ id: item })),
      };
    });
};
